import * as React from 'react';
import {View, StyleSheet} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {Props} from './model';
import {images} from '../../../assets/icons';
import {useNavigation} from '@react-navigation/native';
import {Link} from '../link';
import {Text} from '../text';

// const getPath = (screens: PathConfigMap, screen: Screens): Screens[] => {
//   const path: Screens[] = [];
//   const screenNames = Object.keys(screens);

//   for (let i = 0; i < screenNames.length; i++) {
//     const key = screenNames[i];
//     path.push(key as Screens);

//     if (key === screen) {
//       return path;
//     }

//     if ((screens[key] as PathConfigMap)?.screens) {
//       const subPath = getPath((screens[key] as PathConfigMap)!.screens as PathConfigMap, screen);
//       if (subPath.length) {
//         return path.concat(subPath);
//       }
//     }

//     path.pop();
//   }

//   return [];
// };

export default ({routes, style, ...restProps}: Props) => {
  const styles = useComponentStyles();
  const nav = useNavigation();
  // const path = getPath(linking.config?.screens!, routeName as Screens);

  return (
    <View style={[styles.container, style]} {...restProps}>
      {routes.map((route, index) => {
        const isLast = index === routes.length - 1;

        return (
          <React.Fragment key={route.routeName}>
            {isLast ? (
              <Text
                testID={`breadcrumb-item-${route.routeName}-link-id`}
                style={[styles.text, styles.textActive]}
                ellipsizeMode='clip'
                numberOfLines={1}>
                {route.title}
              </Text>
            ) : (
              <Link
                testID={`breadcrumb-item-${route.routeName}-link-id`}
                screen={route.routeName}
                navigate={nav.navigate}>
                <Text style={styles.text} numberOfLines={1}>
                  {route.title}
                </Text>
              </Link>
            )}
            {!isLast ? (
              <View style={styles.separator}>
                <images.ChevronRight color={StyleSheet.flatten(styles.icon).color} />
              </View>
            ) : null}
          </React.Fragment>
        );
      })}
    </View>
  );
};

const useComponentStyles = () =>
  useStyles(({theme}) => ({
    container: {
      flexGrow: 0,
      flexBasis: 'auto',
      flexShrink: 0,
      flexDirection: 'row',
      alignItems: 'center',
    },
    text: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.gray500,
      maxWidth: 360,
      overflow: 'hidden',
    },
    textActive: theme.fonts.bodySmallLight,
    separator: {
      width: 16,
      height: 16,
      marginHorizontal: 6,
    },
    icon: {
      color: theme.color.gray500,
    },
  }));
